import { ToastType } from './../enums/toast-type.enum';
export class ToastMessage {
  title: string = "";
  body: string = "";
  toastType: ToastType = ToastType.Default;
}
